import type { IApiClientService } from "../../../../legacy/services/ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../../../../legacy/services/AxiosApiClientInstance/AxiosApiClientInstance";
import { Mapper } from "../../../../lib/utils/mapper";
import { getBonusxApiConfigV2 } from "../../../common/bonusxApiConfig";
import { ProductLeanDto } from "../dtos/product-lean/product-lean.dto";
import type { IProductLeanDto } from "../dtos/product-lean/product-lean.dto.interface";
import { ProductsAvailabilitiesDto } from "../dtos/products-availabilities.dto";
import type { IProductsRemoteDatasource } from "./products-remote.datasource.interface";

export class ProductsRemoteDataSource implements IProductsRemoteDatasource {
  private readonly _PRODUCTS_BASE_URL = "/products";
  private readonly _GET_ALL_LEAN_URL = `${this._PRODUCTS_BASE_URL}/new`;

  private readonly _CITIZEN_ID_QUERY_PARAM = "citizenId";
  private readonly _TIMESTAMP_QUERY_PARAM = "timestamp";

  private readonly _CLIENT_OPTIONS = getBonusxApiConfigV2();

  constructor(private readonly _client: IApiClientService = new AxiosApiClientInstance()) {}

  async getAllProductsLean(citizenId: number, timestamp: number): Promise<ProductsAvailabilitiesDto> {
    const url = this._buildGetAllLeanUrl(citizenId, timestamp);

    const { data } = await this._client.get<IProductLeanDto[]>(url, this._CLIENT_OPTIONS);
    const availableProducts: IProductLeanDto[] = [];
    const notAvailableProducts: IProductLeanDto[] = [];

    for (const product of data) {
      const productDto = Mapper.mapData(ProductLeanDto, product);
      if (productDto.available) {
        availableProducts.push(productDto);
      } else {
        notAvailableProducts.push(productDto);
      }
    }

    const splittedProductsByAvailabilities = new ProductsAvailabilitiesDto({
      available: availableProducts,
      notAvailable: notAvailableProducts,
    });
    return splittedProductsByAvailabilities;
  }

  private _buildGetAllLeanUrl(citizenId: number, timestamp: number): string {
    const queryParamsForCaching = new URLSearchParams();
    queryParamsForCaching.set(this._CITIZEN_ID_QUERY_PARAM, `${citizenId}`);
    queryParamsForCaching.set(this._TIMESTAMP_QUERY_PARAM, `${timestamp}`);

    return `${this._GET_ALL_LEAN_URL}?${queryParamsForCaching.toString()}`;
  }
}
